import React from "react";
import styled from "styled-components";
import { Container as ContentsContainer } from "../Editor/Contents/styles";
import {
    highlightChanges,
    HIGHLIGHT_ADDED,
    HIGHLIGHT_REMOVED,
} from "./helpers";

const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 100px;
    justify-content: space-between;
    border-top: 1px solid #ccc;
`;

const Contents = styled(ContentsContainer)`
    position: unset;
    display: flex;
    flex-direction: column;
    width: 47%;
    padding: 50px 1.5% 50px 0;

    & > div:first-child {
        font-size: 16px;
    }
`;

const Divider = styled.div`
    position: relative;
    border-left: 1px solid #ccc;
`;

type Props = {
    src: string;
    dst: string;
};
type State = {};

export default class SplitView extends React.Component<Props, State> {
    srcMarkup() {
        const { src, dst } = this.props;
        const code = highlightChanges(dst, src, HIGHLIGHT_ADDED);

        return {
            __html: code,
        };
    }

    dstMarkup() {
        const { src, dst } = this.props;
        const code = highlightChanges(src, dst, HIGHLIGHT_REMOVED);

        return {
            __html: code,
        };
    }

    render() {
        return (
            <Container>
                <Contents>
                    <div dangerouslySetInnerHTML={this.srcMarkup()} />
                </Contents>

                <Divider />

                <Contents>
                    <div dangerouslySetInnerHTML={this.dstMarkup()} />
                </Contents>
            </Container>
        );
    }
}
